import PubSub from 'pubsub-js';
import { throttle } from 'lodash';

let w = window;
let previous = w.scrollY;
let $w = $(w);

w.addEventListener('scroll', throttle(() => {
  let y = w.scrollY;

  PubSub.publish('window:scroll', { top: y, direction: y > previous ? 'down' : 'up' });

  previous = y;
}, 50));

w.addEventListener('resize', throttle(function() {
  PubSub.publish('window:resize', { width: $w.width(), height: $w.height() });
}, 100));



// WEBPACK FOOTER //
// ./scripts/lib/window-scroll-events.js